import useI18n from '../../common/hooks/useI18n';
import { IFlat } from '../../common/model/flat.model';
import { IOffice } from '../../common/model/office.model';

import FlatsDisplay from '../shared/flatsDisplay';

type Props = {
  closedFlats: IFlat[];
  offices: IOffice[];
};

const ClosedFlatsSection: React.FC<Props> = ({ closedFlats, offices }) => {
  const i18n = useI18n();

  return (
    <div>
      <FlatsDisplay
        flats={closedFlats}
        offices={offices}
        title={i18n.t('search.messages.recentlySold')}
        centerMode
        arrows={true}
      />
    </div>
  );
};

export default ClosedFlatsSection;
